import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { LeftSideMenuComponent } from './layout-components/left-side-menu/left-side-menu.component';
import { FooterComponent } from './layout-components/footer/footer.component';
import { MainContentComponent } from './layout-components/main-content/main-content.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonDataService } from './common/services/common-data.service';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/Login/Login.component';
import { RightOverlayComponent } from './layout-components/right-overlay/right-overlay.component';
import { ClickOutsideDirective } from './common/directives/click-outside.directive';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProvideFeedbackComponent } from './common/shared-components/provide-feedback/provide-feedback/provide-feedback.component';
import { LocationBreadcrumbComponent } from './common/shared-components/location-breadcrumb/location-breadcrumb.component';
import { BookmarkComponent } from './common/shared-components/bookmark/bookmark.component';
import { XBLRElementsComponent } from './common/shared-components/xblr-elements/xblr-elements.component';
import { AnnotationsComponent } from './common/shared-components/annotations/annotations.component';
import { YourAnnotationComponent } from './common/shared-components/your-annotation/your-annotation.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ConfigurationService } from './common/services/configuration.service';
import { LoginService } from './common/services/Login.service';
import { NgxCaptchaModule } from "ngx-captcha";
import { ValidationService } from './common/services/validation.service';
import { NotificationComponent } from './common/shared-components/notification/notification.component';
import { MasterGlossaryComponent } from './components/master-glossary/master-glossary.component';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { HighlightSearchTermPipe } from './common/pipes/highlight-search-term.pipe';
import { ErrorComponent } from './common/shared-components/error/error.component'
import { DatePipe } from '@angular/common';
import { GraphqlService } from './common/services/graphql.service';
import { SharedModule } from './common/shared.module';
import { AutoFocusDirective } from './common/directives/auto-focus.directive';
import { GeneralFeedbackComponent } from './common/shared-components/general-feedback/general-feedback.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './common/shared-components/confirm-dialog/confirm-dialog.component';
import { MyHistoryComponent } from './components/my-history/my-history.component';
import { MyAnnotationsComponent } from './components/my-annotations/my-annotations.component';
import { MyBookmarkComponent } from './components/my-bookmark/my-bookmark.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { CopyrightComponent } from './components/copyright/copyright.component';
import { HelpComponent } from './components/help/help.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { PendingcontentComponent } from './components/pending-content/pendingcontent.component';
import { ConceptsStatementsComponent } from './components/concepts-statements/concepts-statements.component';
import { PendingContentAgreementComponent } from './components/pending-content-agreement/pending-content-agreement.component';
import { MatRadioModule } from '@angular/material/radio';
import { ContactSupportComponent } from './components/Login/contact-support/contact-support.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { PendingContentAgreementCheckService } from './common/services/pending-content-agreement-check.service';
import { ClearSessionsService } from './common/services/clear-sessions.service';
import { AICPAComponent } from './components/aicpa/aicpa.component';
import { ArchiveComponent } from './common/shared-components/archive/archive.component';
import { InlineGlossaryComponent } from './common/shared-components/inline-glossary/inline-glossary.component';
import { SupersededStandardsComponent } from './components/superseded-standards/superseded-standards.component';
import { CrossReferenceComponent } from './components/cross-reference/cross-reference.component';
import { TableComponent } from './common/shared-components/table/table.component';
import { PendingContentIntegerationComponent } from './components/pending-content-integeration/pending-content-integeration.component';
import { CrossReferenceFeatureComponent } from './components/cross-reference-feature/cross-reference-feature.component';
import { StandardTypeAcronymsComponent } from './components/standard-type-acronyms/standard-type-acronyms.component';
import { PublicationModule } from './modules/publication/publication.module';
import { NoticeToConstituentsComponent } from './components/notice-to-constituents/notice-to-constituents.component';
import { SearchComponent } from './components/search/search.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SafeHTMLPipe } from './common/pipes/safe-html.pipe';
import { HostListenerClickDirective } from './common/directives/host-listener-click.directive';
import { PendingcontentsystemFAQComponent } from './components/pendingcontentsystem-faq/pendingcontentsystem-faq.component';
import { WhatLinksHereComponent } from './common/shared-components/what-links-here/what-links-here.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SearchContentComponent } from './common/shared-components/search-content/search-content.component';
import { GlossaryTermUsageComponent } from './common/shared-components/glossary-term-usage/glossary-term-usage.component';
import { GlossaryTermTopicComponent } from './common/shared-components/glossary-term-topic/glossary-term-topic.component';
import { CookieComponent } from './common/shared-components/cookie/cookie.component';
import { RelatedPraposedASUSComponent } from './common/shared-components/related-praposed-asus/related-praposed-asus.component';
import { HelpRelatedExposureDraftsComponent } from './components/help-related-exposure-drafts/help-related-exposure-drafts.component';
import { HelpAnnotationsComponent } from './components/help/help-annotations/help-annotations.component';
import { HelpArchiveContentComponent } from './components/help/help-archive-content/help-archive-content.component';
import { HelpBasisforConclusionsComponent } from './components/help/help-basisfor-conclusions/help-basisfor-conclusions.component';
import { HelpBookmarksComponent } from './components/help/help-bookmarks/help-bookmarks.component';
import { HelpBrowsingComponent } from './components/help/help-browsing/help-browsing.component';
import { HelpCrossreferenceComponent } from './components/help/help-crossreference/help-crossreference.component';
import { HelpFeedbackComponent } from './components/help/help-feedback/help-feedback.component';
import { HelpGlossariesComponent } from './components/help/help-glossaries/help-glossaries.component';
import { HelpGotoComponent } from './components/help/help-goto/help-goto.component';
import { HelpJACContentComponent } from './components/help/help-jaccontent/help-jaccontent.component';
import { HelpPendingcontentComponent } from './components/help/help-pendingcontent/help-pendingcontent.component';
import { HelpPrintingComponent } from './components/help/help-printing/help-printing.component';
import { HelpSearchingComponent } from './components/help/help-searching/help-searching.component';
import { HelpXbrlfeatureComponent } from './components/help/help-xbrlfeature/help-xbrlfeature.component';
import { HelpSeccontentComponent } from './components/help/help-seccontent/help-seccontent.component';
import { HelpPendingcontentSystemComponent } from './components/help/help-pendingcontent-system/help-pendingcontent-system.component';
import { HelpAbouttheCodificationComponent } from './components/help/help-aboutthe-codification/help-aboutthe-codification.component';
import { HelpCopyAndPasteComponent } from './components/help/help-copy-and-paste/help-copy-and-paste.component';
import { CloserightOverlay } from './common/directives/closeRightOverlay.directive';
import { HelpDisplayoptionComponent } from './components/help/help-displayoption/help-displayoption.component';
import { HelpMyascComponent } from './components/help/help-myasc/help-myasc.component';
import { HelpMyhistoryComponent } from './components/help/help-myhistory/help-myhistory.component';
import { HelpRelatedProposedAsusComponent } from './components/help/help-related-proposed-asus/help-related-proposed-asus.component';
import { NgxPrintModule } from 'ngx-print';
import { SessionService } from './common/services/Session.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ConceptStatementsComponent } from './components/concept-statements/concept-statements.component';
import { BackButtonComponent } from './common/shared-components/back-button/back-button.component';
import { ScrollToTopComponent } from './common/shared-components/scroll-to-top/scroll-to-top.component';
import { CrossReferenceTableComponent } from './common/shared-components/cross-reference-table/cross-reference-table.component';
import { AccessManagementComponent } from './components/access-management/access-management.component';
import { AddUserComponent } from './common/shared-components/add-user/add-user.component';

import { RouteGaurdService } from './common/services/route-gaurd.service';
import { XbrldataComponent } from './components/xbrldata/xbrldata.component';
import { TaxonomyelementreffileComponent } from './taxonomyelementreffile/taxonomyelementreffile.component';
import { RedisCacheManagementComponent } from './components/redis-cache-management/redis-cache-management.component';
import { InternalViewRouteGuardService } from './common/services/internal-view-route-guard.service';
import { InternalAdminViewRouteGuardService } from './common/services/internal-admin-view-route-guard.service';
import { CacheControlInterceptor } from './common/interceptors/cache-control.interceptor';
import { PDFBackupLandingPageComponent } from './components/pdfbackup-landing-page/pdfbackup-landing-page.component';
import { MatTreeModule } from '@angular/material/tree';
import { PDFBackupGaurdService } from './common/services/PDF-Backup-guard.service';


@NgModule({
  declarations: [
    AppComponent,
    LeftSideMenuComponent,
    FooterComponent,
    MainContentComponent,
    HomeComponent,
    LoginComponent,
    RightOverlayComponent,
    ClickOutsideDirective,
    ProvideFeedbackComponent,
    LocationBreadcrumbComponent,
    BookmarkComponent,
    XBLRElementsComponent,
    AnnotationsComponent,
    YourAnnotationComponent,
    NotificationComponent,
    MasterGlossaryComponent,
    HighlightSearchTermPipe,
    ErrorComponent,
    AutoFocusDirective,
    GeneralFeedbackComponent,
    ConfirmDialogComponent,
    MyHistoryComponent,
    MyAnnotationsComponent,
    MyBookmarkComponent,
    AboutUsComponent,
    CopyrightComponent,
    ContactUsComponent,
    HelpComponent,
    PendingcontentComponent,
    ConceptsStatementsComponent,
    TermsAndConditionsComponent,
    ContactSupportComponent,
    PendingContentAgreementComponent,
    ArchiveComponent,
    PendingContentAgreementComponent,
    AICPAComponent,
    InlineGlossaryComponent,
    SupersededStandardsComponent,
    CrossReferenceComponent,
    TableComponent,
    CrossReferenceFeatureComponent,
    StandardTypeAcronymsComponent,
    PendingContentIntegerationComponent,
    NoticeToConstituentsComponent,
    SearchComponent,
    SafeHTMLPipe,
    HostListenerClickDirective,
    PendingcontentsystemFAQComponent,
    WhatLinksHereComponent,
    SearchContentComponent,
    GlossaryTermUsageComponent,
    GlossaryTermTopicComponent,
    CookieComponent,
    RelatedPraposedASUSComponent,
    HelpRelatedExposureDraftsComponent,
    HelpAnnotationsComponent,
    HelpArchiveContentComponent,
    HelpBasisforConclusionsComponent,
    HelpBookmarksComponent,
    HelpBrowsingComponent,
    HelpCrossreferenceComponent,
    HelpFeedbackComponent,
    HelpGlossariesComponent,
    HelpGotoComponent,
    HelpJACContentComponent,
    HelpPendingcontentComponent,
    HelpPrintingComponent,
    HelpSearchingComponent,
    HelpXbrlfeatureComponent,
    HelpSeccontentComponent,
    HelpPendingcontentSystemComponent,
    HelpAbouttheCodificationComponent,
    HelpCopyAndPasteComponent,
    CloserightOverlay,
    HelpDisplayoptionComponent,
    HelpMyascComponent,
    HelpMyhistoryComponent,
    HelpRelatedProposedAsusComponent,
    ConceptStatementsComponent,
    BackButtonComponent,
    ScrollToTopComponent,
    CrossReferenceTableComponent,
    AccessManagementComponent,
    AddUserComponent,
    XbrldataComponent,
    TaxonomyelementreffileComponent,
    RedisCacheManagementComponent,
    PDFBackupLandingPageComponent
  ],
  imports: [
    PublicationModule,
    SharedModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatGridListModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatCardModule,
    MatToolbarModule,
    MatRadioModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatBadgeModule,
    MatSlideToggleModule,
    NgxCaptchaModule,
    MatListModule,
    MatSidenavModule,
    MatExpansionModule,
    MatDialogModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatRadioModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    NgxPrintModule,
    MatProgressSpinnerModule,
    MatTreeModule
  ],
  entryComponents: [
    ConfirmDialogComponent
  ],
  providers: [MatNativeDateModule, CommonDataService, ConfigurationService, LoginService, PDFBackupGaurdService, ValidationService, GraphqlService, DatePipe, PendingContentAgreementCheckService, ClearSessionsService, SessionService, Title, RouteGaurdService, InternalViewRouteGuardService, InternalAdminViewRouteGuardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheControlInterceptor,
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
